import { t } from "i18next";
import toast from "react-hot-toast";
import { SnackbarError } from "../../base/SnackbarAlert/SnackbarError";

export function useFormClientSideErrorsHandler() {
    return {
        onError: (errors) => {
            console.log(errors);
            Object.entries(errors).forEach(([key, value]) => {
                if (!value) {
                    return;
                }
                toast.custom(
                    () => (
                        <SnackbarError
                            // @ts-ignore
                            message={t(value.message) || "Wystąpił błąd TODO"}
                        />
                    ),
                    {
                        position: "bottom-right",
                    },
                );
            });
        },
    };
}

// TODO: Standarize backend errors
export function useFormServerSideErrorsHandler() {
    return {
        onServerError: (error) => {
            console.log(error);
            const getErrorMessage = (errorCode) => {
                console.log("errorCode", errorCode);
                switch (errorCode) {
                    case "duplicate_pesel":
                        return t("clients.passportDialog.duplicatePeselError");
                    case "duplicate_id_card":
                        return t("clients.passportDialog.duplicateIdCardError");
                    case "duplicate_passport":
                        return t("clients.passportDialog.duplicatePassportError");
                    case "enter_a_valid_email_address":
                        return t("clients.passportDialog.enterAValidEmailAddressError");
                    case "offer_send_error":
                        return t("offers.OfferEditDialog.sendFailed");
                    case "bank_with_this_bank_name_already_exists":
                        return t("bankings.bank_with_this_bank_name_already_exists");
                    case "banking_with_this_banking_name_already_exists":
                        return t("bankings.banking_with_this_banking_name_already_exists");
                    case "banking_with_this_banking_nr_already_exists":
                        return t("bankings.banking_with_this_banking_nr_already_exists");
                    case "bank_matching_query_does_not_exist":
                        return t("bankings.bank_matching_query_does_not_exist");
                    case "bankingkind_matching_query_does_not_exist":
                        return t("bankings.bankingkind_matching_query_does_not_exist");
                    case "invest_matching_query_does_not_exist":
                        return t("bankings.invest_matching_query_does_not_exist");
                    case "banking_nr_must_have_exactly_26_characters":
                        return t("bankings.banking_nr_must_have_exactly_26_characters");
                    case "invalid_format_of_banking_nr":
                        return t("bankings.invalid_format_of_banking_nr");
                    case "duplicate_banking_invest_for_current_bill":
                        return t("bankings.duplicate_banking_invest_for_current_bill");
                    case "translated_error":
                        return t(error.response.data.translation_key);
                    default:
                        return "Wystąpił nieznany błąd.";
                }
            };

            const errorMessage = getErrorMessage(error?.response.data.error_code || "");
            toast.custom(() => <SnackbarError message={errorMessage} />, {
                position: "bottom-right",
            });
        },
    };
}
